import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

import { DarkModeContext } from '../context/DarkModeContext';
import { COLORS } from '../common/constants';

const Title = ({ title, symbol }) => {
	const { isDarkModeOn } = useContext(DarkModeContext);
	return (
		<TitleStyled isDarkModeOn={isDarkModeOn}>
			{title}
			<Emoji>{symbol}</Emoji>
		</TitleStyled>
	);
};

export default Title;

// 🎨 Styled Components
const TitleStyled = styled.h1`
	font-size: calc(30px + (36 - 30) * ((100vw - 300px) / (1600 - 300)));
	padding-bottom: 0.625rem;
	font-family: myriad-pro, sans-serif;
	font-weight: 700;
	text-align:left;
	color: ${COLORS.grey};
	/* ${(props) =>
		props.isDarkModeOn &&
		css`
			color: ${COLORS.white};
		`} */

	&::selection{
		background-color:${COLORS.somOrange};
		color:${COLORS.white}
	}
`;

const Emoji = styled.span`
	font-size: 1.875rem;
	padding-left: 0.5rem;
	position: relative;
	bottom: 0.2rem;
	letter-spacing: 0.25rem;
`;
